<div class="grid field col-12">
  @if (messages.length > 0) {
    <div class="grid field col-12">
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="toMessageSeverity(m.severity)"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }
  @if (waiting) {
    <div class="grid field col-12">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (everythingReady) {
    <div class="grid field col-12">
      <div class="col-12 md:col-10"><h2 style="margin-bottom:2px; padding-bottom:0px;">Jobs</h2></div>
      <div class="col-12 md:col-2">
        <button pButton type="button" (click)="navigateToAddJob()" style="width:100px; margin-top:20px; float:right; vertical-align:bottom;">
          <i pButtonIcon class="fa fa-plus"></i>
          <span pButtonLabel>Add</span>
        </button>
      </div>
      <div class="grid field col-12">
        <p-table #dt [columns]="cols" [value]="jobs" [scrollable]="true"  [paginator]="true" [rows]="25" [loading]="!everythingReady">
          <ng-template #colgroup let-columns>
            <colgroup>
            @for (col of columns; track col) {
              <col [style.width]="col.width"/>
            }
          </colgroup>
        </ng-template>
        <ng-template #header let-columns>
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field">
                {{col.header}}
                @if (col.field != '') {
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                }
              </th>
            }
          </tr>
          <tr>
            @for (col of columns; track col) {
              <th>
                @switch (col.field) {
                  @case ('name') {
                    <div>
                      <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;"
                        />
                      </div>
                    }
                    @case ('company.name') {
                      <div>
                        <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;" />
                      </div>
                    }
                    @case ('devices') {
                      <div style="width: 100%;">
                        <input pInputText type="text" (input)="dt.filter($event.target.value, col.alternativeFilterField, col.filterMatchMode)" style="width: 100%;" />
                        <!-- <p-multiSelect [options]="deviceNamesSelection" placeholder="All Devices" (onChange)="dt.filter($event.value, col.alternativeFilterField, col.filterMatchMode)" appendTo="body"></p-multiSelect> -->
                      </div>
                    }
                  }
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-job>
            <tr>
              <td>{{job.name}}</td>
              <td>{{(job.company) ? job.company.name : "" }}</td>
              <td>{{job.startTime | date: 'MM/dd/yy HH:mm'}}</td>
              <td>{{job.endTime | date: 'MM/dd/yy HH:mm'}}</td>
              <!-- <td><span *ngFor="let device of job.devices; index as i" [attr.data-index]="i">{{(i > 0) ? ', ' + device.label : device.label}}</span></td> -->
              <td>{{job.deviceNamesAsString}}</td>
              <td>
                <!-- <div style="display:block">
                <button pButton
                  icon="far fa-edit"
                  (click)="navigateToDetail(job.id)"
                  style="margin:auto; max-width:35px;">
                </button>
                <button pButton
                  icon="far fa-trash-alt"
                  (click)="confirmDelete(job)"
                  style="margin:auto; max-width:35px; margin-left:5px;">
                </button>
              </div> -->
              <i class="far fa-edit" (click)="navigateToDetail(job.id)" style="margin-right:5px;" pTooltip="Navigate to Details for this Job."></i>
              <i class="far fa-chart-bar" (click)="navigateToDashboard(job.id)" style="margin-right:5px;" pTooltip="Navigate to the Job Dashboard."></i>
              <i class="fa fa-book" (click)="navigateToWorkbook(job)" style="margin-right:5px;" pTooltip="Navigate to the Job Workbook."></i>
              @if (isEditorOrAdmin(job)) {
                <i class="fa fa-table" (click)="downloadJobExport(job.id)" style="margin-right:5px;" pTooltip="Download the Job 'DATA' Export"></i>
              }
              @if (isEditorOrAdmin(job)) {
                <i class="far fa-file" (click)="downloadJobSummaryExport(job.id)" style="margin-right:5px;" pTooltip="Download the Job 'SUMMARY' Export"></i>
              }
              <!-- pop up blocker is getting this one because of async look up-->
              <!-- <i class="far fa-chart-bar" (click)="navigateToDashboard(job.id)" style="margin-right:5px;"></i> -->
              @if (isAdmin(job)) {
                <i class="far fa-trash-alt" (click)="confirmDelete(job)" pTooltip="Delete this Job."></i>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template #paginatorleft>
          Showing {{(dt.totalRecords) < 1 ? 0 : ((dt.first ?? 0) + 1)}} to
          {{(dt.totalRecords) > 0 ? (((dt.rows ?? 0) + (dt.first ?? 0)) <= (dt.totalRecords) ? ((dt.rows ?? 0) + (dt.first ?? 0)) :
          (dt.totalRecords)) : 0}} of {{dt.totalRecords}} entries
        </ng-template>
      </p-table>
    </div>
    <div class="col-12 md:col-6"></div>
    @if (postJobAnalysisFeatureenabled) {
      <div class="col-12 md:col-3">
        <button pButton type="button" (click)="navigateToPostJobAnalysis()" style="width:180px; margin-top:10px; float:right; vertical-align:bottom;text-align: right;">
          <i pButtonIcon class="far fa-chart-bar"></i>
          <span pButtonLabel>Post Job Analysis</span>
        </button>
      </div>
    }
  </div>
}
</div>

